import { render, staticRenderFns } from "./attendArea.vue?vue&type=template&id=19d8511f&scoped=true&"
import script from "./attendArea.vue?vue&type=script&lang=js&"
export * from "./attendArea.vue?vue&type=script&lang=js&"
import style0 from "./attendArea.vue?vue&type=style&index=0&id=19d8511f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8511f",
  null
  
)

export default component.exports